module.exports = __webpack_public_path__ + "static/media/substract-circle.1a2ea526.svg";